// extracted by mini-css-extract-plugin
module.exports = {"heading":"header-module--heading--1R2Ly","logo":"header-module--logo--3gu8x","button":"header-module--button--1RlJH","navBar":"header-module--navBar--3awEy"};